import React from 'react'
import  BetterResponsesContext from '../../../contexts/BetterResponsesContext'
import { ResponseDisplay } from "../responsedisplay/ResponseDisplay"
import StatusContext from '../../../contexts/StatusContext';

import { NavBarBetterResponse } from '../../main/navbarbetterresponse/NavBarBetterResponse'
import { PromptWithIcon } from '../promptwithicon/PromptWithIcon';
import { PushButton } from '../pushbutton/PushButton'
import { AvailableCredits } from '../availablecredits/AvailableCredits'

import Stack from '@mui/material/Stack'

import "./betterresponses.css"
import { WaitonResponse } from '../waitonresponse/WaitonResponse'
import { DialogProgressBettertResponses } from './DialogProgressBetterResponses';
import { AlertDialog } from '../alertdialog/AlertDialog'



export const BetterResponses = () => {

 
  let {
    promptsandresponses,
    confirmDelete,
    onDeletePrompt,
    changeConfirmDelete,

    onClearChat,
 
    chatPrompt,
    setChatPrompt,
    onSubmitChat,
    status,
    
    onResubmitChat,
  

  } = React.useContext( BetterResponsesContext);

  let {
    isMobile, 
    scrollRef,
    changeLanguage,
   
    openDialog,
    openDialogBox,
    closeDialogBox,
    
    onCopy,
    focusRef,
   
    
  } = React.useContext(StatusContext);


  const alertYes = () => {
    onClearChat()
    closeDialogBox()
  }

  const alertCancel = () => {
    closeDialogBox()
  }



  return (

    <div className="homeContainer">
       
  
          <NavBarBetterResponse title={changeLanguage('betterresponses', 'navbartitle')} />

        
       
        <div className="response-markdown" ref={scrollRef}>

         
            {
              Array.isArray(promptsandresponses) &&
              promptsandresponses.map((item) => (
                <ResponseDisplay key={item.id} displayprompt={item} displayicons={confirmDelete[promptsandresponses.indexOf(item)].state}
                  changeConfirmDelete={changeConfirmDelete} onDeletePrompt={onDeletePrompt} onResubmitQuestion={onResubmitChat} onCopy={onCopy} displayprovidername={false}/>
              ))
            }
        
        </div>
        {
          (!status) &&
            <WaitonResponse />
        }
        <hr className = 'separator'></hr>
        
        <PromptWithIcon prompt={chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmitChat} placeholdertext={changeLanguage('common', 'promptplaceholder')} />
       
        {
          (status) && <label className='statusLabel'>{status}</label>
        }
        
        <div ref = {focusRef} className="mainButtons">
         
          <Stack direction = "row" spacing={2}>
          
            <PushButton onClick={openDialogBox} label={changeLanguage('common', 'clearall')} />
          
          </Stack>
          <AvailableCredits />
         
        
        </div>
        <label style={{ width:  isMobile() ? '100%' : '60%' }}>{changeLanguage("betterresponses", "note")}</label>

        <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog={openDialog} closeDialog={closeDialogBox} prompt={changeLanguage('dialog', 'cleardata')} />
        <DialogProgressBettertResponses />
    </div>

  )
}


